// NPM Imports
import React, { useContext, useState, useEffect } from 'react'
// Quote Context
import { useQuoteContext } from '../../../hooks/useQuoteContext'
// Bootstrap Imports
import Form from 'react-bootstrap/Form'
import InputGroup from 'react-bootstrap/InputGroup'
import OverlayTrigger from 'react-bootstrap/OverlayTrigger'
import Tooltip from 'react-bootstrap/Tooltip'

export default function PriceBookSelect({ size = 'sm' }) {
   const state = useQuoteContext()
   const permissions = state.featurePermissions['PricebookSelectExternalStyle']
   const [showTooltip, setShowTooltip] = useState(false)
   const [tooltipPlacement, setTooltipPlacement] = useState('right')
   const { getString } = state

   let buttonStyle
   if (permissions.includes(state.user_role))
      buttonStyle = { 'min-width': '120px' }
   else buttonStyle = {}

   // Determine tooltip placement based on screen width
   useEffect(() => {
      const updatePlacement = () => {
         const screenWidth = window.innerWidth
         // Use left placement if screen is narrow (less than 768px)
         setTooltipPlacement(screenWidth < 768 ? 'left' : 'right')
      }

      updatePlacement()
      window.addEventListener('resize', updatePlacement)
      return () => window.removeEventListener('resize', updatePlacement)
   }, [])

   // Generate tooltip content for currency restrictions
   const getTooltipContent = () => {
      if (state.previousCurrencyCode === 'USD') {
         return null // No restrictions when previous currency is USD
      }

      const disabledCurrencies = state.pricebooks
         ?.filter((p) => {
            return !(
               state.previousCurrencyCode === 'USD' ||
               p.currencyCode === 'USD' ||
               p.currencyCode === state.previousCurrencyCode
            )
         })
         .map((p) => p.currencyCode)
         .filter((code, index, arr) => arr.indexOf(code) === index) // unique currencies

      if (disabledCurrencies && disabledCurrencies.length > 0) {
         return `Some pricebooks are disabled due to currency conversion restrictions. Only USD ↔ other currency or same currency (${state.previousCurrencyCode}) conversions are allowed. Disabled: ${disabledCurrencies.join(', ')}`
      }
      return null
   }

   const tooltipContent = getTooltipContent()

   const selectElement = (
      <Form.Select
         value={state.pricebookId || ''}
         onChange={(e) => {
            state.setPricebookId(e.target.value)
            setShowTooltip(false) // Hide tooltip when selection is made
         }}
         onFocus={() => {
            if (tooltipContent) {
               setShowTooltip(true) // Show tooltip when dropdown is clicked/focused
            }
         }}
         onBlur={() => {
            setShowTooltip(false) // Hide tooltip when dropdown loses focus
         }}
      >
         {state.pricebookSelectorList}
      </Form.Select>
   )

   return (
      <InputGroup
         style={buttonStyle}
         className='justify-content-center'
         size={size}
      >
         <InputGroup.Text size={size}>
            {getString('product.PriceBookSelect.InputText')}
         </InputGroup.Text>
         {tooltipContent ? (
            <OverlayTrigger
               show={showTooltip}
               placement={tooltipPlacement}
               overlay={<Tooltip>{tooltipContent}</Tooltip>}
               trigger={[]} // Disable default hover/focus triggers
            >
               {selectElement}
            </OverlayTrigger>
         ) : (
            selectElement
         )}
      </InputGroup>
   )
}
